import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from '~/ssrAdapter/react-router-dom';

import { TestimonialCarousel } from '~/components/Marketing';
import {
	FrequentlyAskedQuestions,
	PricingBrandsBanner,
	PricingHero,
} from '~/components/Pricing';
import Zendesk from '~/components/Zendesk';
import { PLANS } from '~/constants';
import featureFlags from '~/constants/featureFlags';
import analytics from '~/services/analytics';
import usePageTrack from '~/services/analytics/usePageTrack';
import { localeSelectors } from '~/services/locale';
import { signupActions } from '~/services/signup';
import { loginActions } from '~/services/login';
import { workspacesSelectors } from '~/services/workspaces';

const Pricing = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const currency = useSelector(localeSelectors.getCurrency);
	const workspaceFlags = useSelector(
		workspacesSelectors.getCurrentWorkspaceFlags,
	);

	usePageTrack({
		name: analytics.events.PRICING,
		category: analytics.events.category.MARKETING,
		debugEventCategories: ['plan', 'page'],
		currency,
	});

	const onChoosePlan = useCallback(
		({ plan, planInterval, source }) => {
			analytics.track(analytics.events.PRICING_TABLE_SIGNUP_CLICKED, {
				plan,
				planInterval,
				source,
			});
			if (
				(plan === PLANS.BUSINESS && !workspaceFlags.businessRepackaging) ||
				plan === PLANS.ENTERPRISE
			) {
				history.push('/contact-us');
				return;
			}

			if (plan !== PLANS.FREE && featureFlags.signupPricingRedirect) {
				dispatch(
					signupActions.setPostSignupRedirectUrl({
						url: `/plan/confirm/${plan}/${planInterval}`,
					}),
				);
				dispatch(
					loginActions.setPostLoginRedirectUrl({
						url: `/plan/confirm/${plan}/${planInterval}`,
					}),
				);
			}
			history.push('/signup');
		},
		[dispatch, history, workspaceFlags.businessRepackaging],
	);

	return (
		<main role="main">
			<Zendesk />
			<PricingHero onChoosePlan={onChoosePlan} />
			<PricingBrandsBanner />
			<TestimonialCarousel />
			<FrequentlyAskedQuestions />
		</main>
	);
};

export default Pricing;
